module.exports = __webpack_public_path__ + "static/img/third3_1_4.1bd4af6e.jpg";